import React, { useContext, useEffect, useState } from 'react';
import { SecondaryButton } from '../../../Core/FormInput';
import { Grid } from '@material-ui/core';
import parse from 'html-react-parser';

const LoanVehicleTermsNdCondition = (props) => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                {parse(props?.termsOfService || '')}
            </Grid>
            <Grid item xs={12} md={6}>
                <SecondaryButton fullWidth onClick={() => props.onSubmit(true)}>
                    Agree
                </SecondaryButton>
            </Grid>
            <Grid item xs={12} md={6}>
                <SecondaryButton fullWidth onClick={props.onClose}>
                    Cancel
                </SecondaryButton>
            </Grid>
        </Grid>
    );
};
export default LoanVehicleTermsNdCondition;
